import { Link } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 sm:gap-3">
            <img 
              src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/f34ba2532ff159722b540fefc621ff3a.png" 
              alt="Haruka Fitness" 
              className="h-10 sm:h-12 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="bg-[#F04D7A] text-white px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-sm sm:text-base font-medium hover:bg-[#E03A68] transition-all whitespace-nowrap cursor-pointer"
          >
            ホームに戻る
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-8 sm:mb-12 text-center">
          プライバシーポリシー
        </h1>

        <div className="prose prose-sm sm:prose-base lg:prose-lg max-w-none space-y-8">
          <div className="text-sm sm:text-base text-[#333333] leading-relaxed">
            <p className="mb-6">
              ハルカフィットネス（以下、「当方」といいます。）は、本ウェブサイト上で提供するサービス（以下、「本サービス」といいます。）における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
            </p>
          </div>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第1条（個人情報）
            </h2>
            <p className="text-sm sm:text-base text-[#333333] leading-relaxed">
              「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第2条（個人情報の収集方法）
            </h2>
            <p className="text-sm sm:text-base text-[#333333] leading-relaxed">
              当方は、ユーザーが利用登録をする際に氏名、生年月日、住所、電話番号、メールアドレス、銀行口座番号、クレジットカード番号などの個人情報をお尋ねすることがあります。また、ユーザーと提携先などとの間でなされたユーザーの個人情報を含む取引記録や決済に関する情報を、当方の提携先（情報提供元、広告主、広告配信先などを含みます。以下、｢提携先｣といいます。）などから収集することがあります。
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第3条（個人情報を収集・利用する目的）
            </h2>
            <p className="text-sm sm:text-base text-[#333333] leading-relaxed mb-4">
              当方が個人情報を収集・利用する目的は、以下のとおりです。
            </p>
            <ol className="list-decimal list-inside space-y-2 text-sm sm:text-base text-[#333333] leading-relaxed pl-4">
              <li>当方サービスの提供・運営のため</li>
              <li>ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）</li>
              <li>ユーザーが利用中のサービスの新機能、更新情報、キャンペーン等及び当方が提供する他のサービスの案内のメールを送付するため</li>
              <li>メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
              <li>利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため</li>
              <li>ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため</li>
              <li>有料サービスにおいて、ユーザーに利用料金を請求するため</li>
              <li>上記の利用目的に付随する目的</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第4条（利用目的の変更）
            </h2>
            <ol className="list-decimal list-inside space-y-3 text-sm sm:text-base text-[#333333] leading-relaxed pl-4">
              <li>当方は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものといます。</li>
              <li>利用目的の変更を行った場合には、変更後の目的について、当方所定の方法により、ユーザーに通知し、または本ウェブサイト上に公表するものといます。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第5条（個人情報の第三者提供）
            </h2>
            <ol className="list-decimal list-inside space-y-3 text-sm sm:text-base text-[#333333] leading-relaxed pl-4">
              <li>
                当方は、次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
                <ol className="list-decimal list-inside space-y-2 mt-2 ml-6">
                  <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                  <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                  <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
                  <li>
                    予め次の事項を告知あるいは公表し、かつ当方が個人情報保護委員会に届出をしたとき
                    <ul className="list-disc list-inside mt-2 ml-6">
                      <li>利用目的に第三者への提供を含むこと</li>
                      <li>第三者に提供されるデータの項目</li>
                      <li>第三者への提供の手段または方法</li>
                      <li>本人の求めに応じて個人情報の第三者への提供を停止すること</li>
                      <li>本人の求めを受け付ける方法</li>
                    </ul>
                  </li>
                </ol>
              </li>
              <li>
                前項の定めにかかわらず、次に掲げる場合には、当該情報の提供先は第三者に該当しないものとします。
                <ol className="list-decimal list-inside space-y-2 mt-2 ml-6">
                  <li>当方が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合</li>
                  <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
                  <li>個人情報を特定の者との間で共同して利用する場合であって、その旨並びに共同して利用される個人情報の項目、共同して利用する者の範囲、利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について、あらかじめ本人に通知し、または本人が容易に知り得る状態に置いた場合</li>
                </ol>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第6条（アクセス解析ツールについて）
            </h2>
            <p className="text-sm sm:text-base text-[#333333] leading-relaxed">
              当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。このトラフィックデータは匿名で収集されており、個人を特定するものではありません。この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。この規約に関して、詳しくは
              <a 
                href="https://marketingplatform.google.com/about/analytics/terms/jp/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#F04D7A] hover:underline"
              >
                こちら
              </a>
              をクリックしてください。
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第7条（個人情報の開示・訂正・削除）
            </h2>
            <p className="text-sm sm:text-base text-[#333333] leading-relaxed">
              ユーザーから個人情報の開示、訂正、追加、削除、利用停止、消去などを求められた場合、ご本人であることを確認させていただいた上で、速やかに対応いたします。
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第8条���プライバシーポリシーの変更）
            </h2>
            <ol className="list-decimal list-inside space-y-3 text-sm sm:text-base text-[#333333] leading-relaxed pl-4">
              <li>本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。</li>
              <li>当方が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第9条（お問い合わせ窓口）
            </h2>
            <p className="text-sm sm:text-base text-[#333333] leading-relaxed mb-4">
              本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。
            </p>
            <div className="bg-[#FFF8FA] p-6 rounded-lg space-y-2 text-sm sm:text-base text-[#333333]">
              <p><strong>住所：</strong>東京都立川市</p>
              <p><strong>社名：</strong>ハルカフィットネス</p>
              <p><strong>担当：</strong>お問い合わせ担当</p>
              <p><strong>連絡方法：</strong>LINE公式アカウント（@harukafitness）</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-4 border-l-4 border-[#F04D7A] pl-4">
              第10条（制定日・改定日）
            </h2>
            <div className="text-sm sm:text-base text-[#333333] leading-relaxed space-y-2">
              <p><strong>制定：</strong>2025年1月1日</p>
              <p><strong>改定：</strong>2025年1月1日</p>
            </div>
          </section>
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#F04D7A] text-white px-8 py-3 rounded-full text-base font-bold hover:bg-[#E03A68] transition-all shadow-lg hover:shadow-xl cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            ホームに戻る
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#2B2B2B] text-white py-12 sm:py-16 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid md:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
            <div>
              <img 
                src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/f34ba2532ff159722b540fefc621ff3a.png" 
                alt="Haruka Fitness" 
                className="h-10 sm:h-12 w-auto mb-2"
              />
              <p className="text-xs sm:text-sm text-gray-400">あなたらしく、美しく</p>
            </div>

            <div>
              <h5 className="text-sm sm:text-base font-bold mb-3 sm:mb-4">Follow Us</h5>
              <a
                href="https://www.instagram.com/haruka_fitness?igsh=d3R3a2JoNnpvMWsx&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-[#F04D7A] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl sm:text-2xl"></i>
                <span className="text-xs sm:text-sm">Instagram</span>
              </a>
            </div>

            <div>
              <h5 className="text-sm sm:text-base font-bold mb-3 sm:mb-4">Contact</h5>
              <a
                href="https://line.me/R/ti/p/@harukafitness"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs sm:text-sm text-gray-400 hover:text-[#F04D7A] transition-colors cursor-pointer"
              >
                LINE公式アカウント
              </a>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-400">
            <p>© 2025 Haruka Fitness. All rights reserved.</p>
            <div className="flex items-center gap-4 sm:gap-6">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">プライバシーポリシー</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
